import { render, staticRenderFns } from "./Francecard.vue?vue&type=template&id=e7038e86&scoped=true&"
import script from "./Francecard.vue?vue&type=script&lang=js&"
export * from "./Francecard.vue?vue&type=script&lang=js&"
import style0 from "./Francecard.vue?vue&type=style&index=0&id=e7038e86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7038e86",
  null
  
)

export default component.exports